<template>
  <div class="config-container">
    <div v-if="currentStep===1">
      <h2>
        1. Insert email list (separated by ',' ';' or ' ')
      </h2>
      <div ref="emails-input" />
      <VButton :on-click="searchUsers" :is-loading="loading">
        Run search
      </VButton>
    </div>
    <div v-if="currentStep===2">
      <h2>
        2. Anonymise found users
      </h2>
      <h3>Users not found</h3>
      <div class="emails emails-input">
        <span class="email-chip invalid" v-for="email in notFoundUserEmails" :key="email">
          <span class="content">{{ email }}</span>
        </span>
      </div>
      <h3>Users found</h3>
      <UserChipList :users="foundUsers" :on-remove="removeFoundUser" />
      <VButton :on-click="anonymizeUsers" :is-loading="loading" :disabled="foundUsers.length===0">
        Anonymise selected users
      </VButton>
    </div>
    <div v-if="currentStep===3">
      <h2>
        3. Anonymisation process
      </h2>
      <p>Warning, don't leave this page until the process is done</p>
      <UserChipList :users="foundUsers" />
      <h3>Failed Anonymized users</h3>
      <UserChipList :users="failedAnonymizedUsers" :is-invalid="true" />
      <h3>Anonymized users</h3>
      <UserChipList :users="anonymizedUsers" />
    </div>
  </div>
</template>
<script>

import EmailsInput from '../shared/EmailsInput/EmailsInput'
import VButton from '../shared/VButton'
import UserChipList from '../shared/EmailsInput/UserChipList'

export default {
  name: 'AnonymisationPage',
  components: { UserChipList, VButton },
  data() {
    return {
      emailsInput: null,
      foundUsers: [],
      notFoundUserEmails: [],
      anonymizedUsers: [],
      failedAnonymizedUsers: [],
      currentStep: 1,
      loading: false
    }
  },
  async mounted() {
    if (this.currentStep === 1) {
      this.emailsInput = EmailsInput(this.$refs['emails-input'], {
        pasteSplitPattern: /[,; ]+/
      })
    }
  },
  destroyed() {
    this.emailsInput && this.emailsInput.destroy()
  },
  methods: {
    getValidEmails() {
      return this.emailsInput.getValue().filter((value, index, self) => {
        return self.indexOf(value) === index
      })
    },
    async searchUsers() {
      this.loading = true
      let emails = this.getValidEmails()
      if (emails.length > 0) {
        this.foundUsers = await this.$store.dispatch('searchUsersByEmails', emails)
        let foundEmails = this.foundUsers.map(u => u.email)
        this.notFoundUserEmails = emails.filter(email => !foundEmails.includes(email))
        this.emailsInput && this.emailsInput.destroy()
        this.currentStep = this.currentStep + 1
        this.loading = false
      }
    },
    removeFoundUser(userToRemove) {
      this.foundUsers = this.foundUsers.filter(user => user.id !== userToRemove.id)
    },
    async anonymizeUsers() {
      this.loading = true
      this.currentStep = 3
      for (let user of this.foundUsers) {
        await this.$store.dispatch('anonymiseUser', user.id)
          .then(() => {
            this.anonymizedUsers.push(user)
          }).catch(e => {
            this.failedAnonymizedUsers.push(user)
            this.$toasted.global.error(`Unknown error during anonymisation of user ${user.email} : ${e.message}`)
          })
        this.removeFoundUser(user)
      }
      this.loading = false
    }
  }
}
</script>
<style scoped lang="scss">

.config-container {
  margin: 20px;
  padding-bottom: 50px;
}

.emails.emails-input .email-chip.user-chip {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0.625rem 0 0;
}

.user-chip > :first-child {
  margin: 0;
}

.button-remove {
  margin-left: 32px;
}

h3 {
  margin-top: 1.5em
}
</style>
